/* Ein Ein/Aus-Zustand, der pro Gerät im Browser gemerkt wird.
 *
 * Gedacht für Ansichtseinstellungen (etwa: Abschnitt aufgeklappt), nicht für
 * Angaben, die zwischen Geräten übereinstimmen müssen — dafür taugt
 * localStorage nicht, siehe useNotifications.js.
 *
 * Lesen und Schreiben können scheitern (privates Fenster, gesperrte
 * Website-Daten). Das ist kein Fehlerfall: Ohne lesbaren Wert gilt `initial`,
 * und ein Zustand, der sich nicht speichern lässt, gilt nur für diese Sitzung.
 * Der Aufrufer merkt davon nichts.
 */

import { ref, watch } from 'vue';

const ON = '1';
const OFF = '0';

export function useStoredToggle(key, initial = false) {
  let start = initial;
  if (key) {
    try {
      const raw = localStorage.getItem(key);
      if (raw === ON) start = true;
      else if (raw === OFF) start = false;
    } catch {
      /* nicht lesbar: Vorgabe gilt */
    }
  }

  const state = ref(start);

  /* Nur bei einer Änderung schreiben, nicht schon beim Anlegen — sonst würde
     jeder Seitenaufruf die Vorgabe festschreiben. */
  if (key) {
    watch(state, (value) => {
      try {
        localStorage.setItem(key, value ? ON : OFF);
      } catch {
        /* nicht kritisch: gilt dann nur für diese Sitzung */
      }
    });
  }

  return state;
}
